import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-summary',
  templateUrl: './alert-summary.component.html',
  styleUrls: ['./alert-summary.component.css']
})
export class AlertSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
